import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import AlertSnackbar from 'bento-ordering/base/components/AlertSnackbar';
import { ALL_ONLINE_ORDERING_FULFILLMENT_METHODS } from 'bento-ordering/cart/constants/fulfillmentOptions';
import { isMobileMedia } from 'bento-ordering/utils/media';

const Message = ({ itemQuantity }) => {
  return (
    <span>
      <Typography component="p" variant="h6">
        <strong>
          {`${itemQuantity} ${
            itemQuantity < 2 ? 'item' : 'items'
          } added to your order!`}
        </strong>
      </Typography>
      <Typography component="p" variant="subtitle1">
        See if we can deliver to you, or switch to pickup.
      </Typography>
    </span>
  );
};

const NoSetAddressSnackbar = ({
  open,
  onClose,
  availableFulfillmentOptions,
  metaData
}) => {
  const itemQuantity = metaData.latestItemQuantity;

  return (
    <AlertSnackbar
      availableFulfillmentOptions={availableFulfillmentOptions}
      onClose={onClose}
      open={open}
      message={Message({ itemQuantity })}
      vertical={isMobileMedia() ? 'bottom' : 'top'}
    />
  );
};

NoSetAddressSnackbar.defaultProps = {
  open: false,
  onClose: () => {},
  metaData: {}
};

NoSetAddressSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  availableFulfillmentOptions: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
  ),
  metaData: PropTypes.object
};

Message.propTypes = {
  itemQuantity: PropTypes.number
};

export default NoSetAddressSnackbar;
